$(document).ready(function(){


  //scroll to # on load
  //$(window).load(function(){
    // Remove the # from the hash, as different browsers may or may not include it
    //var hash = location.hash.replace('#','');

    //if(hash != ''){
    //	var hashVal = location.hash;
       // Clear the hash in the URL
       // location.hash = '';   // delete front "//" if you want to change the address bar
    //    $('html, body').animate({ scrollTop: $(hashVal).offset().top-200}, 1000);

    //   }
   //});


  //scroll to hash on click
	$('.js-scroll').on('click',function() {
		var url = $(this).attr('href'),
            target = url.substring(url.indexOf("#")+1),
            target = $("#"+target);

        if($('header.header').length){
            var offset = $('header.header').outerHeight();
        } else {
            var offset = 0;
        }

        if($(this).data('scroll-offset')){
            offset = offset + $(this).data('scroll-offset');
        }

        $('html,body').animate({
        	scrollTop: target.offset().top - offset
       	}, 1000);
        return false;
	});

});